import { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import ActivityTypes from '@/constants/ActivityTypes';

export default function useStudentRedirect() {
  const router = useRouter();
  const globalContext = useContext(GlobalContext);

  useEffect(() => {
    if (
      router.isReady &&
      globalContext.state.loaded &&
      globalContext.state?.user?.student
    ) {
      if (globalContext.state.user?.student) {
        let url = '/student/dashboard';
        const activityTypeSlugs = Object.values(ActivityTypes.toSlug);

        const [, urlActivityType] = router.asPath.split('/');
        const activityType =
          router.query.activityType ||
          activityTypeSlugs.find(
            (activityTypeSlug) => urlActivityType == activityTypeSlug
          );
        if (activityType) {
          url = `/student/activitiesBySlug/${activityType}`;
          if (router.query.activitySlug) {
            url += `/${router.query.activitySlug}`;
          }
        }
        router.replace(url);
        return;
      }
    }
  }, [globalContext.state, router.isReady]);
}
